import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";
import { catchError, map } from "rxjs/operators";
import { EdpResponseBody } from "@edp-models/response.model";
import { Observable, of } from "rxjs";
import { Reading, ReadingsFactory } from "@edp-pages/readings/components/readings-model";

@Injectable({
    providedIn: "root",
})
export class ReadingsService {

    constructor(private apiService: ApiService) {
    }

    public getReadingsByType(contractId: string, supplyType: string, meterId: string = ""): Observable<Reading[][]> {
        const payload = !!meterId ? { contractId, supplyType, meter: meterId } : { contractId, supplyType };
        return this.apiService.callServicePost("reading.getReadings", payload).pipe(
            map((response: EdpResponseBody) => {
                return response.Result.Collection.map(readings => this.createReading(readings));
            }),
            catchError(error => of([]))
        );
    }

    public getResourceId(contractId: string, supplyType: string): Observable<any> {
        return this.apiService.callServicePost("reading.createReadingsFile", { contractId, supplyType }).pipe(
            map((response: EdpResponseBody) => {
                return response.Result.Collection.resourceId;
            })
        );
    }

    public createReading(reading): Reading[] {
        const readings = [];
        reading.forEach((item: {
            FV: any;
            LT: any;
            P: any;
            S: any;
            V: any;
            VN: any;
            C: any;
            contractId: any;
            readingDate: any;
            endBillingPeriod: any;
            eqNumber: any;
            estimatedDays: any;
            mrType: any;
            realDays: any;
            startBillingPeriod: any;
            readingStatus: any;
            supplyType: any;
            unit: any;
        }) => {
            readings.push(ReadingsFactory.create({
                FV: item.FV,
                LT: item.LT,
                P: item.P,
                S: item.S,
                V: item.V,
                VN: item.VN,
                C: item.C,
                contractId: item.contractId,
                readingDate: item.readingDate,
                endBillingPeriod: item.endBillingPeriod,
                eqNumber: item.eqNumber,
                estimatedDays: item.estimatedDays,
                mrType: item.mrType,
                realDays: item.realDays,
                startBillingPeriod: item.startBillingPeriod,
                readingStatus: item.readingStatus,
                supplyType: item.supplyType,
                unit: item.unit
            } as Reading));
        });
        return readings;
    }


}
